"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M9 7.574c0-.538.446-.974.995-.974h4.01c.55 0 .995.436.995.974V9.31L12.261 12 15 14.69v1.736a.985.985 0 01-.995.974h-4.01A.985.985 0 019 16.426V14.69L11.739 12 9 9.31V7.574z" }), "Waiting");
//# sourceMappingURL=Waiting.js.map